import { render, staticRenderFns } from "./LoadingDots.vue?vue&type=template&id=6c7282e8&"
import script from "./LoadingDots.vue?vue&type=script&lang=ts&"
export * from "./LoadingDots.vue?vue&type=script&lang=ts&"
import style0 from "./LoadingDots.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports